<section class="section thank-page-section" [class.mobile]="topService.isMobile">
  <div class="wrapper">
      <h1 class="text-center">Thank you for your submission,<br/>we will be in touch with you shortly</h1>
      <a [routerLink]="['/contact-support']" class="getstarted-link color-white">Go back</a>
  </div>
</section>